import { render, staticRenderFns } from "./CompetitionCases.vue?vue&type=template&id=717a2903&scoped=true"
import script from "./CompetitionCases.vue?vue&type=script&lang=js"
export * from "./CompetitionCases.vue?vue&type=script&lang=js"
import style0 from "./CompetitionCases.vue?vue&type=style&index=0&id=717a2903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a2903",
  null
  
)

export default component.exports